export const SN_UTIL = 'util'
export const UTIL_CALENDARS_UPDATED = SN_UTIL + '/CALENDARS_UPDATED'
export const UTIL_PRODUCT_STORES_UPDATED = SN_UTIL + '/PRODUCT_STORES_UPDATED'
export const UTIL_FACILITY_TYPES_UPDATED = SN_UTIL + '/FACILITY_TYPES_UPDATED'
export const UTIL_FACILITY_GROUP_TYPES_UPDATED = SN_UTIL + '/FACILITY_GROUP_TYPES_UPDATED'
export const UTIL_LOCATION_TYPES_UPDATED = SN_UTIL + '/LOCATION_TYPES_UPDATED'
export const UTIL_COUNTRIES_UPDATED = SN_UTIL + '/COUNTRIES_UPDATED'
export const UTIL_EXTERNAL_MAPPING_TYPES_UPDATED = SN_UTIL + '/EXTERNAL_MAPPING_TYPES_UPDATED'
export const UTIL_PARTY_ROLES_UPDATED = SN_UTIL + '/PARTY_ROLES_UPDATED'
export const UTIL_STATES_UPDATED = SN_UTIL + '/STATES_UPDATED'
export const UTIL_SHOPIFY_SHOP_UPDATED = SN_UTIL + '/SHOPIFY_SHOP_UPDATED'
export const UTIL_INVENTORY_GROUP_UPDATED = SN_UTIL + '/INVENTORY_GROUP_UPDATED'
export const UTIL_ORGANIZATION_PARTY_ID_UPDATED = SN_UTIL + '/ORGANIZATION_PARTY_ID_UPDATED'
